import apiClient from "../helpers/ApiClient";

// --- LINEN ITEMS & CONDITIONS ---
export const getLaundryItems = async () => {
  const res = await apiClient.get("/laundry/items");
  return res.data;
};

export const createLaundryItem = async (data) => {
  const res = await apiClient.post("/laundry/items", data);
  return res.data;
};

export const updateLaundryItem = async (id, data) => {
  const res = await apiClient.put(`/laundry/items/${id}`, data);
  return res.data;
};

export const adjustLinenCondition = async (data) => {
  const res = await apiClient.post("/laundry/items/condition-transfer", data);
  return res.data;
};

export const getLinenMovements = async (itemId = null, limit = 50) => {
  const res = await apiClient.get("/laundry/items/movements", {
    params: { item_id: itemId, limit }
  });
  return res.data;
};

// --- ROOM USAGE ---
export const getLaundryRoomUsage = async () => {
  const res = await apiClient.get("/laundry/usage");
  return res.data;
};

export const logLaundryRoomUsage = async (data) => {
  const res = await apiClient.post("/laundry/usage", data);
  return res.data;
};

// --- VENDORS & RATES ---
export const getLaundryVendors = async () => {
  const res = await apiClient.get("/laundry/vendors");
  return res.data;
};

export const createLaundryVendor = async (data) => {
  const res = await apiClient.post("/laundry/vendors", data);
  return res.data;
};

export const updateLaundryVendor = async (id, data) => {
  const res = await apiClient.put(`/laundry/vendors/${id}`, data);
  return res.data;
};

export const getVendorRates = async (vendorId) => {
  const res = await apiClient.get(`/laundry/vendors/${vendorId}/rates`);
  return res.data;
};

export const saveVendorRates = async (vendorId, rates) => {
  const res = await apiClient.post(`/laundry/vendors/${vendorId}/rates`, { rates });
  return res.data;
};

// --- DISPATCHES, PARTIAL RECEIPTS & AP INVOICING ---
export const getLaundryDispatches = async () => {
  const res = await apiClient.get("/laundry/dispatches");
  return res.data;
};

export const getLaundryDispatchDetails = async (id) => {
  const res = await apiClient.get(`/laundry/dispatches/${id}`);
  return res.data;
};

export const createLaundryDispatch = async (data) => {
  const res = await apiClient.post("/laundry/dispatches", data);
  return res.data;
};

export const receiveLaundryDispatch = async (id, data) => {
  const res = await apiClient.post(`/laundry/dispatches/${id}/receive`, data);
  return res.data;
};

export const getDispatchReceipts = async (id) => {
  const res = await apiClient.get(`/laundry/dispatches/${id}/receipts`);
  return res.data;
};

export const generateVendorBill = async (id, data) => {
  const res = await apiClient.post(`/laundry/dispatches/${id}/generate-bill`, data);
  return res.data;
};

// --- RECONCILIATIONS ---
export const getReconciliations = async (status = null) => {
  const res = await apiClient.get("/laundry/reconciliations", {
    params: { status }
  });
  return res.data;
};

export const createReconciliation = async (data) => {
  const res = await apiClient.post("/laundry/reconciliations", data);
  return res.data;
};

export const approveReconciliation = async (id, data) => {
  const res = await apiClient.post(`/laundry/reconciliations/${id}/approve`, data);
  return res.data;
};

// --- DASHBOARD & REPORTS ---
export const getLaundryDashboardStats = async () => {
  const res = await apiClient.get("/laundry/dashboard-stats");
  return res.data;
};

export const getLaundryReports = async (params = {}) => {
  const res = await apiClient.get("/laundry/reports", { params });
  return res.data;
};

// --- GUEST ORDERS ---
export const getGuestOrders = async () => {
  const res = await apiClient.get("/laundry/guest-orders");
  return res.data;
};

export const createGuestOrder = async (data) => {
  const res = await apiClient.post("/laundry/guest-orders", data);
  return res.data;
};

export const updateGuestOrderStatus = async (id, status) => {
  const res = await apiClient.patch(`/laundry/guest-orders/${id}/status`, { status });
  return res.data;
};

// --- BATCHES ---
export const getBatches = async () => {
  const res = await apiClient.get("/laundry/batches");
  return res.data;
};

export const createBatch = async (data) => {
  const res = await apiClient.post("/laundry/batches", data);
  return res.data;
};

export const updateBatchStatus = async (id, status) => {
  const res = await apiClient.patch(`/laundry/batches/${id}/status`, { status });
  return res.data;
};

// --- MACHINES & CHEMICALS ---
export const getMachines = async () => {
  const res = await apiClient.get("/laundry/machines");
  return res.data;
};

export const createMachine = async (data) => {
  const res = await apiClient.post("/laundry/machines", data);
  return res.data;
};

export const getChemicals = async () => {
  const res = await apiClient.get("/laundry/chemicals");
  return res.data;
};

export const createChemical = async (data) => {
  const res = await apiClient.post("/laundry/chemicals", data);
  return res.data;
};

// --- UNIFORMS ---
export const getUniforms = async () => {
  const res = await apiClient.get("/laundry/uniforms");
  return res.data;
};

export const createUniform = async (data) => {
  const res = await apiClient.post("/laundry/uniforms", data);
  return res.data;
};

export const updateUniformStatus = async (id, status) => {
  const res = await apiClient.patch(`/laundry/uniforms/${id}/status`, { status });
  return res.data;
};
